import React from 'react';

export default function Timeline({ events = [] }) {
 return (
 <div className="flow-root">
 <ul className="-mb-8">
 {events.map((event, eventIdx) => (
 <li key={event.id || eventIdx}>
 <div className="relative pb-8">
 {eventIdx !== events.length - 1 ? (
 <span className="absolute top-4 left-4 -ml-px h-full w-0.5 bg-surface-muted" aria-hidden="true" />
 ) : null}
 <div className="relative flex space-x-3">
 <div>
 <span className={`h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white ${event.iconBg || 'bg-primary'}`}>
 {event.icon || <div className="h-2.5 w-2.5 rounded-full bg-surface" />}
 </span>
 </div>
 <div className="flex min-w-0 flex-1 justify-between space-x-4 pt-1.5">
 <div>
 <p className="text-sm text-subtle">
 {event.content}{' '}
 <span className="font-medium text-primary">{event.target}</span>
 </p>
 </div>
 <div className="whitespace-nowrap text-right text-sm text-subtle">
 <time dateTime={event.datetime}>{new Date(event.datetime).toLocaleDateString()}</time>
 </div>
 </div>
 </div>
 </div>
 </li>
 ))}
 </ul>
 </div>
 );
}
